/*********** Footer Script START**************/

if ($(window).width() < 767){
 $('footer .footer-block__heading').each(function(){
    $(this).click(function(){
        $(this).siblings('.footer-block__details-content').slideToggle();
        $(this).toggleClass('active');
    })
 })
}

$( document ).ready(function() {
  $(".readMore").on('click', function(){
    $('.productDescriptionShort').addClass('hide');
    $('.productDescriptionFull').removeClass('hide');
  });
  $(".readLess").on('click', function(){
    $('.productDescriptionFull').addClass('hide');
    $('.productDescriptionShort').removeClass('hide');
  });
});


// Made to order and Estimate delivery JS Start
$(document).ready(function () {

  // Helper function to format a Date object like "Aug 30"
  function formatDate(date) {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  // Calculate start and end dates
  const today = new Date();
  const startDate = new Date();
  const endDate = new Date();

  startDate.setDate(today.getDate() + 15); // e.g., 10 days from now
  endDate.setDate(today.getDate() + 20);   // e.g., 15 days from now

  // Format dates
  const formattedStart = formatDate(startDate);
  const formattedEnd = formatDate(endDate);


  function toggleNoteField() {
    var selected = $('input[type="radio"][name^="Size"]:checked').val();
    if (selected === 'Made to order') {
      $('.madeToOrder').html(
        `
        <div class="estimated-delivery">
          <p><strong>Estimated delivery: ${formattedStart} - ${formattedEnd}</strong></p>
        </div>
        <div class="made-to-order-note-container" style="margin-bottom: 2rem;">
        <div class="madeToOrderField">
          <p for="ContactForm-name">Enter your custom size or details:</p>
          <textarea autocomplete="name" type="text" id="ContactForm-name" name="properties[Made to Order Note]" value="" placeholder="e.g. Wrist size, engraving note..."></textarea>
        </div>
      </div>`
      );
    } else {
      $('.madeToOrder').html('');
    }
  }

  // Delegate event to document in case radios are re-rendered
  $(document).on('change', 'input[type="radio"][name^="Size"]', function () {
    toggleNoteField();
  });

  // Initial check on page load
  toggleNoteField();

});
/*********** Footer Script END**************/